export default function getCandidate(state) {
    return state.studentPanelMetaData;
}